/* eslint-disable react/prop-types */
// src/context/UserContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";

const UserContext = createContext(undefined);

export const UserProvider = ({ children }) => {
  const auth = useAuth();
  const [userData, setUserData] = useState({});

  // Poblar datos cuando esté autenticado
  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      setUserData({
        email:
          auth.user.profile?.email ||
          (typeof auth.user.profile?.["cognito:username"] === "string"
            ? auth.user.profile["cognito:username"].split("_").pop()
            : undefined),
        idToken: auth.user.id_token,
        accessToken: auth.user.access_token,
        refreshToken: auth.user.refresh_token,
        expiresAt: auth.user.expires_at, // timestamp UNIX
        userID: auth.user?.profile.sub,
      });
    }
  }, [auth.isAuthenticated, auth.user]);

  // Verificar expiración del token cada 10 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);

      if (userData.expiresAt && now >= userData.expiresAt) {
        console.warn("Token expirado. Cerrando sesión automáticamente...");
        auth.removeUser(); // limpia los datos de sesión
        setUserData({});
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [userData.expiresAt, auth]);

  return (
    <UserContext.Provider value={userData}>{children}</UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
